export const LITERACY_INSIGHT_DATA_TYPE = 'literacy-insight-modal-link';
